
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"34","viewBox":"0 0 34 34","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('rect',{attrs:{"width":"34","height":"34","rx":"3","fill":"#D10600"}}),_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M10 13.294C10 10.771 12.008 9 14.337 9c3.068 0 4.152 2.869 4.152 6.407 0 .03-2.134 1.813-2.134 4.913 0 2.402 1.05 3.169 2.105 3.602l.062.24s-5.766 1.222-5.766-4.46c0-2.049 1.103-3.05 1.103-4.864 0-.582-.503-1.398-1.6-1.398-1.042 0-1.616.777-1.616 1.386l-.22.004A3.148 3.148 0 0110 13.294zm13.497 8.243s-.064-1.087-.721-1.087c-.589 0-.913.537-.913.537s.68.547.68 1.398c0 .878-1.77 1.741-2.529 1.888a3.664 3.664 0 01-.275-1.364c0-1.93 1.281-3.727 3.353-3.727 1.533 0 .66 2.41.66 2.41l-.255-.055zm-2.543-5.509c0 .366-.28.666-.636.666-.352 0-.637-.3-.637-.666a.65.65 0 01.637-.664c.355 0 .636.297.636.664zm1.831-2.332s.606.664.606 1.721c0 1.056-.728 2.492-.728 2.492l-.352-.078s.636-1.361-.843-2.587c-1.362-1.127-1.513-.775-1.705-2.057-.101-.695.129-1.641.47-2.275l.225.084c-.007 1.183.407 2.03.407 2.03s.69-.05 1.024.08c0 .005.37-.877.292-2.105l.228-.092c.746 1.395.376 2.787.376 2.787z","fill":"#fff"}})])
          )
        }
      }
    